import { render, staticRenderFns } from "./ProductOrderSelector.vue?vue&type=template&id=1af7bb4c&scoped=true"
import script from "./ProductOrderSelector.vue?vue&type=script&lang=js"
export * from "./ProductOrderSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductOrderSelector.vue?vue&type=style&index=0&id=1af7bb4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af7bb4c",
  null
  
)

export default component.exports